export var THEME_DATA_ATTRIBUTE = 'data-theme';
export var COLOR_MODE_ATTRIBUTE = 'data-color-mode';
export var CONTRAST_MODE_ATTRIBUTE = 'data-contrast-mode';
export var CUSTOM_THEME_ATTRIBUTE = 'data-custom-theme';
export var CSS_PREFIX = 'ds';
export var CSS_VAR_FULL = ['opacity', 'font', 'space', 'border'];
export var TOKEN_NOT_FOUND_CSS_VAR = "--".concat(CSS_PREFIX, "-token-not-found");
export var CURRENT_SURFACE_CSS_VAR = "--".concat(CSS_PREFIX, "-elevation-surface-current");